/**
 * The ARC - A simple guide to how ARA Wealth works
 * 
 * Alignment → Rhythm → Capacity
 * 
 * This is a doctrine page, not a feature page.
 * Keep calm, minimal, scroll-based design.
 */
import { AppLayout } from "./DashboardPage";

export default function TheARCPage() {
  return (
    <AppLayout>
      <div className="max-w-2xl mx-auto px-6 py-12" data-testid="the-arc-page">
        {/* Header */}
        <header className="mb-16 text-center">
          <h1 className="font-heading text-3xl font-semibold text-[#1a4d3e] mb-3">
            The ARC
          </h1>
          <p className="text-[#1a4d3e]/60 text-lg">
            A simple guide to how ARA Wealth works.
          </p>
        </header>

        {/* Sections */}
        <div className="space-y-20">
          
          {/* Section 1 */}
          <section className="space-y-4" data-testid="arc-section-1">
            <h2 className="font-heading text-xl font-medium text-[#1a4d3e]">
              Why ARA Wealth Exists
            </h2>
            <div className="text-[#1a4d3e]/70 leading-relaxed space-y-4">
              <p>Money rarely breaks households overnight. Drift does.</p>
              <p>
                Small assumptions.<br />
                Unspoken stress.<br />
                Delayed conversations.
              </p>
              <p>ARA Wealth helps you close the week calmly so drift doesn't build.</p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="space-y-4" data-testid="arc-section-2">
            <h2 className="font-heading text-xl font-medium text-[#1a4d3e]">
              What Weekly Closure Means
            </h2>
            <div className="text-[#1a4d3e]/70 leading-relaxed space-y-4">
              <p>This isn't about tracking every dollar.</p>
              <p>It's about:</p>
              <ul className="space-y-1 pl-4">
                <li>• Seeing what moved</li>
                <li>• Confirming alignment</li>
                <li>• Starting fresh</li>
              </ul>
              <p>
                When both partners press "Reconciliation Complete," the week is contained.
              </p>
              <p>
                Nothing lingers.<br />
                Nothing hides.<br />
                Nothing builds quietly.
              </p>
            </div>
          </section>

          {/* Section 3 */}
          <section className="space-y-4" data-testid="arc-section-3">
            <h2 className="font-heading text-xl font-medium text-[#1a4d3e]">
              Calm First
            </h2>
            <div className="text-[#1a4d3e]/70 leading-relaxed space-y-4">
              <p>
                We don't use urgency.<br />
                We don't shame.<br />
                We don't pressure.
              </p>
              <p>The weekly reset should feel predictable and light.</p>
              <p>Boring is good.</p>
              <p>
                Boring builds rhythm.<br />
                Rhythm builds trust.
              </p>
            </div>
          </section>

          {/* Section 4 */}
          <section className="space-y-4" data-testid="arc-section-4">
            <h2 className="font-heading text-xl font-medium text-[#1a4d3e]">
              Alignment Over Control
            </h2>
            <div className="text-[#1a4d3e]/70 leading-relaxed space-y-4">
              <p>Alignment does not require merging accounts.</p>
              <p>It requires shared visibility and a steady rhythm.</p>
              <p>
                You can keep autonomy.<br />
                ARA Wealth protects clarity.
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section className="space-y-4" data-testid="arc-section-5">
            <h2 className="font-heading text-xl font-medium text-[#1a4d3e]">
              Growth Happens Quietly
            </h2>
            <div className="text-[#1a4d3e]/70 leading-relaxed space-y-4">
              <p>When rhythm becomes normal, growth becomes natural.</p>
              <p>Consistency builds:</p>
              <ul className="space-y-1 pl-4">
                <li>• Better decisions</li>
                <li>• Stronger savings</li>
                <li>• Clearer direction</li>
                <li>• Long-term wealth</li>
              </ul>
              <p>But it starts small.</p>
              <p className="font-medium text-[#1a4d3e]">
                10 minutes.<br />
                Once a week.<br />
                Together.
              </p>
            </div>
          </section>

        </div>

        {/* Footer spacer */}
        <div className="h-24" />
      </div>
    </AppLayout>
  );
}
